import { InputDay } from '@vrplatform/components';
import { Input as MantineInput } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormInputBaseType } from './_base-input-types';

export const DateInput = ({
  label,
  formKey,
  defaultValue = '',
  required = true,
  disabled,
  placeholder,
  onValueChange,
}: FormInputBaseType) => {
  const { control } = useFormContext();

  return (
    <MantineInput.Wrapper label={label}>
      <Controller
        control={control}
        name={formKey}
        defaultValue={defaultValue}
        rules={{ required: required }}
        render={({ field: { onChange, value } }) => {
          const extendedOnChange = (value: string | undefined) => {
            onValueChange?.(formKey, value);
            onChange(value);
          };

          const onInputChange = (value: string | null) => {
            extendedOnChange(value || undefined);
          };

          return (
            <InputDay
              placeholder={placeholder || label || ''}
              value={value ? value : undefined}
              onChange={onInputChange}
              name={formKey}
              disabled={disabled}
              clearable
              sx={{ input: { borderColor: '#CED0D780' } }}
            />
          );
        }}
      />
    </MantineInput.Wrapper>
  );
};
